// Typography.jsx
import React from 'react';
import '../styles/tokens.css';
import '../styles/Typography.css';

export const Heading = ({
  variant = 'h1', // h1, h2, h3, h4, h5, h6
  className = '',
  color, // brand, normal, inverse, muted
  align, // left, center, right
  children,
  weight, // medium, semibold, bold, black
  style,
  ...props
}) => {
  const Tag = variant;
  const classes = [
    'ds-heading',
    `ds-heading-${variant}`,
    color ? `ds-text-${color}` : 'ds-text-normal',
    align ? `ds-text-${align}` : '',
    weight ? `ds-font-${weight}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} style={style} {...props}>
      {children}
    </Tag>
  );
};

export const Text = ({
  as = 'p',
  size = 'base', // xs, sm, base, lg, xl, 2xl
  weight, // medium, semibold, bold, black
  color, // brand, normal, inverse, muted, subtle
  align, // left, center, right
  className = '',
  children,
  style,
  ...props
}) => {
  const Tag = as;
  const classes = [
    'ds-text',
    `ds-text-${size}`,
    weight ? `ds-font-${weight}` : '',
    color ? `ds-text-${color}` : 'ds-text-muted', // default to muted/gray-600 mostly
    align ? `ds-text-${align}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} style={style} {...props}>
      {children}
    </Tag>
  );
};
